import { Box, Chip, Typography } from '@mui/material';
import CustomAlert from 'components/shared/CustomAlert/CustomAlert';
import CustomAlertContain from 'components/shared/CustomAlert/CustomAlertContain';
import CustomPopOver from 'components/shared/CustomPopOver/CustomPopOver';
import CustomTextField from 'components/shared/CustomTextField/CustomTextField';
import { useInput } from 'customHook/useInput';
import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { BusinessesService } from 'service/businesses.service';
import { ZoomInfoService } from 'service/zoominfo.service';
import zeplinColor from 'theme/Color';
import styles from './ListTagCard.module.css';

const ListTagsCard = ({ isTargeted, data }: { isTargeted: boolean; data: any }) => {
  const location = useLocation();
  const [alert, setAlert] = useState('');
  const [type, setType] = useState('Tag');
  const [loading, setLoading] = useState(false);
  const [targeted, setTargeted] = useState(false);
  const {
    handleChange: handleTagChange,
    handleBlur: handleTagBlur,
    value: tag,
  } = useInput('', () => true);
  const [anchorEl, setAnchorEl] = React.useState<HTMLDivElement | null>(null);
  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  const handleDelete = async (id: string) => {
    try {
      setLoading(true);
      const res = await ZoomInfoService.deleteTarget(id);
      console.log(res);
      setTargeted(false);
      setAlert('Removed target successfully');
    } catch (err) {
      setAlert('Something went wrong.');
    } finally {
      setLoading(false);
    }
  };

  const addTarget = async (id: string) => {
    try {
      const res = await BusinessesService.addTarget({ companyId: `${id}` });
      console.log(res);
      setAlert('Added to target successfully');
      setTargeted(true);
    } catch (err) {
      setAlert('Something went wrong.');
    }
  };
  return (
    <Box
      sx={{
        padding: '16px',
        display: 'flex',
        gap: '16px',
        border: `1px solid ${zeplinColor.Neutral5}`,
        borderRadius: '14px',
        flexDirection: 'column',
      }}
    >
      <Box sx={{ display: 'flex', gap: '16px' }}>
        <Box sx={{ display: 'flex', gap: '8px', width: '58px', alignItems: 'center' }}>
          <img
            src={'/assets/zoominfo-tags.svg'}
            width={'20px'}
            height={'20px'}
            alt='zoominfo-lists'
          />
          <Typography variant='responsiveBody3' color={zeplinColor.Neutral8}>
            Lists
          </Typography>
        </Box>
        <Box sx={{ display: 'flex', gap: '16px', flexWrap: 'wrap' }}>
          {isTargeted || targeted ? (
            <Chip
              icon={<img src={'/assets/zoominfo-check.svg'} width='18px' height='18px' />}
              label='Target account'
              onDelete={() => handleDelete(location?.pathname.split('/')[2] || '')}
              sx={{
                backgroundColor: zeplinColor.BasicBlack,
                color: zeplinColor.Neutral1,
                '& .MuiChip-deleteIcon': {
                  color: zeplinColor.Neutral1,
                  '&:hover': {
                    color: zeplinColor.Neutral4,
                  },
                },
                '&:hover': {
                  backgroundColor: zeplinColor.BasicBlack,
                },
              }}
            />
          ) : (
            <Box
              sx={{
                borderRadius: '28px',
                padding: '6px 12px',
                border: `1px solid ${zeplinColor.BasicBlack}`,
                display: 'flex',
                alignItems: 'center',
                gap: '4px',
                cursor: 'pointer',
              }}
              onClick={() => addTarget(data?.id)}
            >
              <img src={'/assets/add.svg'} width={'18px'} height={'18px'} alt='target account' />
              <Typography variant='responsiveButtonSmall'>Target Account</Typography>
            </Box>
          )}
        </Box>
      </Box>
      <CustomPopOver
        setAnchorEl={setAnchorEl}
        anchorEl={anchorEl}
        id={id}
        sx={{
          borderRadius: '14px',
          boxShadow: 'rgba(0, 0, 0, 0.15)',
          marginTop: '8px',
        }}
      >
        <Box
          sx={{
            padding: { xs: '18px', xl: '24px' },
            display: 'flex',
            gap: { xs: '26px', xl: '32px' },
            flexDirection: 'column',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              width: '100%',
              alignItems: 'center',
            }}
          >
            <Typography variant='responsiveHeading3'>Add {type}</Typography>
            <img
              src={'/assets/close-icon.svg'}
              className={styles['icon-24']}
              alt='close'
              style={{ cursor: 'pointer' }}
              onClick={() => {
                setAnchorEl(null);
              }}
            />
          </Box>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', gap: '16px' }}>
            <CustomTextField
              style={{ width: '100%' }}
              onBlur={handleTagBlur}
              onChange={handleTagChange}
              name={`Enter ${type?.toLocaleLowerCase()} name`}
              text={tag}
              form={true}
              error={false}
              label={`Enter ${type?.toLocaleLowerCase()} name`}
              type='text'
              tabindex={1}
            />
            <Box
              sx={{
                padding: '18px 24px',
                borderRadius: '14px',
                backgroundColor: tag && !loading ? zeplinColor.Brand1 : zeplinColor.Neutral5,
              }}
            >
              <Typography
                variant='responsiveButtonMedium'
                color={tag && !loading ? zeplinColor.Neutral1 : zeplinColor.Neutral8}
              >
                {loading ? 'Adding' : 'Add'}
              </Typography>
            </Box>
          </Box>
        </Box>
      </CustomPopOver>
      <CustomAlert
        open={alert ? true : false}
        handleClose={() => setAlert('')}
        message={
          <CustomAlertContain
            alertIcon={
              alert && !alert?.includes('successfully') ? (
                <img src='/assets/error.svg' width={24} height={24} />
              ) : (
                <img src='/assets/checkmark-green.png' width={24} height={24} />
              )
            }
            alert={alert}
          />
        }
        error={alert && !alert?.includes('successfully') ? true : false}
      />
    </Box>
  );
};

export default ListTagsCard;
